export default function Logo({ className = '' }) {
  return (
    <div className={`text-center ${className}`}>
      <h1 className="text-3xl font-black text-charcoal" style={{ fontFamily: 'Cantarell, sans-serif' }}>
        RENUVIA
      </h1>
    </div>
  );
}
